import { KeyboardKey } from '@/shared/constants';
export default {
  name: 'SimpleOverlay',
  beforeMount: function beforeMount() {
    document.addEventListener('keyup', this.closedByEscKey);
  },
  beforeDestroy: function beforeDestroy() {
    document.removeEventListener('keyup', this.closedByEscKey);
  },
  methods: {
    handleClick: function handleClick() {
      this.$emit('clicked');
    },
    closedByEscKey: function closedByEscKey(event) {
      if (event.key === KeyboardKey.Escape) {
        this.handleClick();
      }
    }
  }
};